// Les 10 du jour (spec § 11) : lecture des raisons écrites par `radar priorities`.

export type PickReason = {
  kind: string;
  at?: string;
  old?: string | null;
  value?: string | null;
  url?: string | null;
};

export type DailyPick = {
  id: number;
  rank: number;
  project_id: string;
  reasons: PickReason[];
  name: string;
  name_fr?: string | null;
  country: string | null;
  phase: string | null;
  score: number | null;
  budget_amount: number | null;
  budget_currency: string | null;
  to_specify: boolean | null;
};

export type DailyPicksToday = {
  day: string | null;
  computed_at: string | null;
  picks: DailyPick[];
};

const KINDS = ["new", "phase", "contractor", "owner", "budget", "contact"];

/** Budget de l'historique, écrit « montant devise ». */
export const parseBudget = (value: string | null | undefined) => {
  const [amount, currency] = (value ?? "").trim().split(/\s+/);
  const number = Number(amount);
  if (!amount || !Number.isFinite(number)) return null;
  return { budget_amount: number, budget_currency: currency ?? null };
};

/** Clé de traduction d'une raison et ses valeurs ; null pour une sorte inconnue. */
export const reasonMessage = (reason: PickReason) => {
  if (!KINDS.includes(reason.kind)) return null;
  const value = reason.value ?? null;
  if (reason.kind === "phase")
    return { key: "phase", phase: value, value: null };
  if (reason.kind === "budget" && !parseBudget(value))
    return { key: "budget_unknown", phase: null, value: null };
  if (reason.kind === "contact" && !value)
    return { key: "contact_unnamed", phase: null, value: null };
  return { key: reason.kind, phase: null, value };
};
